/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  REGISTER_CHANGE_EMAIL_ERROR_HEADING: 'register.registerChangeEmail.error.heading',
  REGISTER_CHANGE_EMAIL_ERROR_LINK_LABEL: 'register.registerChangeEmail.link.label',
  REGISTER_CREATE_USERNAME_PASSWORD_HEADING: 'register.createUsernamePassword.heading',
  REGISTER_CREATE_USERNAME_PASSWORD_PARAGRAPH: 'register.createUsernamePassword.paragraph',
  REGISTER_EMAIL_HEADING: 'register.email.heading',
  REGISTER_EMAIL_PARAGRAPH: 'register.email.paragraph',
  REGISTER_ERROR_HEADING: 'register.bannerError.heading',
  REGISTER_ERROR_LINK_LABEL: 'register.bannerError.link.label',
  REGISTER_ERROR_LOAN_ALREADY_REGISTERED: 'register.bannerError.loanAlreadyRegistered',
  REGISTER_ERROR_LOAN_NOT_ELIGIBLE: 'register.bannerError.loanNotEligible',
  REGISTER_ERROR_LOAN_NOT_FOUND_OR_INVALID: 'register.bannerError.loanNotFoundOrInvalid',
  REGISTER_ERROR_LOAN_NUMBER_INVALID: 'register.bannerError.loanNumberInvalid',
  REGISTER_ERROR_LOAN_NUMBER_REQUIRED: 'register.bannerError.loanNumberRequired',
  REGISTER_ERROR_RETRIEVE_LOAN_INFO: 'register.bannerError.retrieveLoanInfo',
  REGISTER_FORM_HEADING: 'register.form.heading',
  REGISTER_FORM_LOAN_NUMBER_LABEL: 'register.form.loanNumber.label',
  REGISTER_FORM_PARAGRAPH: 'register.form.paragraph',
  REGISTER_FORM_RECAPTCHA_HEADING: 'register.form.recaptcha.heading',
  REGISTER_FORM_SSN_HEADING: 'register.form.ssn.heading',
  REGISTER_FORM_SSN_PARAGRAPH: 'register.form.ssn.paragraph',
  REGISTER_FORM_ZIPCODE_HEADING: 'register.form.zipCode.heading',
  REGISTER_FORM_ZIPCODE_PARAGRAPH: 'register.form.zipCode.paragraph',
  REGISTER_GUIDED_STEP_FOUR_ERROR_HEADING: 'register.guidedStepFour.error.heading',
  REGISTER_GUIDED_STEP_FOUR_ERROR_LINK_LABEL: 'register.guidedStepFour.link.label',
  REGISTER_RESEND_EMAIL_HEADING: 'register.resendEmail.heading',
  REGISTER_RESEND_EMAIL_PARAGRAPH: 'register.resendEmail.paragraph',
  REGISTER_SERVICE_ERROR_EMAIL_IN_USE_HEADING: 'register.serviceError.emailInUse.heading',
  REGISTER_SERVICE_ERROR_EMAIL_IN_USE_LINK_LABEL: 'register.serviceError.emailInUse.link.label',
  REGISTER_SERVICE_ERROR_EMAIL_IN_USE_TEXT: 'register.serviceError.emailInUse.text',
  REGISTER_SERVICE_ERROR_HEADING: 'register.serviceError.heading',
  REGISTER_SERVICE_ERROR_LINK_LABEL: 'register.serviceError.link.label',
  REGISTER_SSO_LOAN_ERROR_HEADING: 'register.ssoLoanError.heading',
  REGISTER_SSO_LOAN_ERROR_LINK_LABEL: 'register.ssoLoanError.link.label',
  REGISTER_STEP_ONE_ERROR_HEADING: 'register.stepOne.error.heading',
  REGISTER_STEP_ONE_ERROR_LINK_LABEL: 'register.stepOne.error.link.label',
  REGISTER_STEP_TWO_ERROR_HEADING: 'register.stepTwo.error.heading',
  REGISTER_STEP_TWO_ERROR_LINK_LABEL: 'register.stepTwo.error.link.label',
  REGISTER_STEP_TWO_VALIDATION_ERROR_HEADING: 'register.stepTwo.validationError.heading',
  REGISTER_STEP_TWO_VALIDATION_ERROR_LINK_LABEL: 'register.stepTwo.validationError.link.label',
  REGISTER_STEP_TWO_VALIDATION_ERROR_TEXT: 'register.stepTwo.validationError.text',
  REGISTER_SUCCESS_HEADING: 'register.succes.heading',
  REGISTER_SUCCESS_LINK_LABEL: 'register.succes.link.label',
  REGISTER_VERIFY_ERROR_HEADING: 'register.verify.error.heading',
  REGISTER_VERIFY_ERROR_LINK_LABEL: 'register.verify.error.link.label',
  REGISTER_VERIFY_SUCCESS_HEADING: 'register.verify.success.heading',
  REGISTER_VERIFY_SUCCESS_LINK_LABEL: 'register.verify.success.link.label',
};

const enMessages = {
  [IDS.REGISTER_CHANGE_EMAIL_ERROR_HEADING]: 'Register - Error',
  [IDS.REGISTER_CHANGE_EMAIL_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_CREATE_USERNAME_PASSWORD_HEADING]: 'Create a username and password',
  [IDS.REGISTER_CREATE_USERNAME_PASSWORD_PARAGRAPH]: 'This information will be needed to set up and log in to your account.',
  [IDS.REGISTER_EMAIL_HEADING]: 'Please enter an email address',
  [IDS.REGISTER_EMAIL_PARAGRAPH]: 'Your email address will be used to contact you for important account updates.',
  [IDS.REGISTER_ERROR_HEADING]: 'We are unable to register your loan at this time',
  [IDS.REGISTER_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_ERROR_LOAN_ALREADY_REGISTERED]: 'Loan is already registered. For assistance, please contact Customer Service.',
  [IDS.REGISTER_ERROR_LOAN_NOT_ELIGIBLE]: 'Loan is not eligible for registration. For assistance, please contact Customer Service.',
  [IDS.REGISTER_ERROR_LOAN_NOT_FOUND_OR_INVALID]: 'Loan not found or data invalid',
  [IDS.REGISTER_ERROR_LOAN_NUMBER_INVALID]: 'Loan number is not valid',
  [IDS.REGISTER_ERROR_LOAN_NUMBER_REQUIRED]: 'Loan Number is required',
  [IDS.REGISTER_ERROR_RETRIEVE_LOAN_INFO]: 'An error has occurred while retrieving your loan information. Please try again. For assistance, please contact Customer Service.',
  [IDS.REGISTER_FORM_HEADING]: "Let's get started.\n What is your loan number?",
  [IDS.REGISTER_FORM_LOAN_NUMBER_LABEL]: 'Loan Number',
  [IDS.REGISTER_FORM_PARAGRAPH]: 'Your 10-digit loan number can be found on mortgage statements and other loan-related documents.',
  [IDS.REGISTER_FORM_RECAPTCHA_HEADING]: 'Before we proceed, please verify that you\'re not a robot',
  [IDS.REGISTER_RESEND_EMAIL_HEADING]: 'Resend Registration Email?',
  [IDS.REGISTER_RESEND_EMAIL_PARAGRAPH]: 'An email has been sent to the following email address: {currentEmail}. Please click on the link within that email to complete the registration process.',
  [IDS.REGISTER_FORM_SSN_HEADING]: 'What are the last 4 digits of your social security number?',
  [IDS.REGISTER_FORM_SSN_PARAGRAPH]: 'You may also use a TIN (9999 format.)',
  [IDS.REGISTER_FORM_ZIPCODE_HEADING]: 'What is your property zip code?',
  [IDS.REGISTER_FORM_ZIPCODE_PARAGRAPH]: 'This is the zip code for the property associated with your loan.',
  [IDS.REGISTER_GUIDED_STEP_FOUR_ERROR_HEADING]: 'Registration - Error',
  [IDS.REGISTER_GUIDED_STEP_FOUR_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_HEADING]: 'A loan is already associated with this email address!',
  [IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_LINK_LABEL]: 'Login Now',
  [IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_TEXT]: 'Please log in using credentials for the existing account associated with this email address. If you can\'t remember your credentials, we can help you retrieve them on the login screen. Once logged in, link a new loan by selecting "Add a New Loan" in the Settings section.',
  [IDS.REGISTER_SERVICE_ERROR_HEADING]: 'Registration - Error',
  [IDS.REGISTER_SERVICE_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_SSO_LOAN_ERROR_HEADING]: "We couldn't register your loan",
  [IDS.REGISTER_SSO_LOAN_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_STEP_ONE_ERROR_HEADING]: 'Registration - Error',
  [IDS.REGISTER_STEP_ONE_ERROR_LINK_LABEL]: 'Register Loan',
  [IDS.REGISTER_STEP_TWO_ERROR_HEADING]: 'Your loan information doesn\'t match our records',
  [IDS.REGISTER_STEP_TWO_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_HEADING]: 'Sorry, this username is taken',
  [IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_LINK_LABEL]: 'Submit New Username',
  [IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_TEXT]: 'Please choose a new username. For questions about registering your loan, contact Customer Service.',
  [IDS.REGISTER_SUCCESS_HEADING]: 'Thank you! We are preparing your account',
  [IDS.REGISTER_SUCCESS_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_VERIFY_ERROR_HEADING]: 'Registration failed',
  [IDS.REGISTER_VERIFY_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.REGISTER_VERIFY_SUCCESS_HEADING]: 'Good News!{spacing}Your account is registered',
  [IDS.REGISTER_VERIFY_SUCCESS_LINK_LABEL]: 'Return to Login',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.REGISTER_ERROR_HEADING]: 'We are unable to register your Murabaha Financing Transaction at this time',
  [IDS.REGISTER_ERROR_LOAN_ALREADY_REGISTERED]: 'Murabaha Financing Transaction is already registered. For assistance, please contact Customer Service.',
  [IDS.REGISTER_ERROR_LOAN_NOT_ELIGIBLE]: 'Account is not eligible for registration. For assistance, please contact Customer Service.',
  [IDS.REGISTER_ERROR_LOAN_NOT_FOUND_OR_INVALID]: 'Account not found or data invalid',
  [IDS.REGISTER_ERROR_RETRIEVE_LOAN_INFO]: 'An error has occurred while retrieving your account information. Please try again. For assistance, please contact Customer Service.',
  [IDS.REGISTER_ERROR_LOAN_NUMBER_INVALID]: 'Account number is not valid',
  [IDS.REGISTER_ERROR_LOAN_NUMBER_REQUIRED]: 'Account number is required',
  [IDS.REGISTER_FORM_HEADING]: "Let's get started.\n What is your account number?",
  [IDS.REGISTER_FORM_LOAN_NUMBER_LABEL]: 'Account Number',
  [IDS.REGISTER_FORM_PARAGRAPH]: 'Your 10-digit account number can be found on Murabaha Financing Transaction statements and other Murabaha Financing Transaction-related documents.',
  [IDS.REGISTER_FORM_ZIPCODE_PARAGRAPH]: 'This is the zip code for the property associated with your Murabaha Financing Transaction.',
  [IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_HEADING]: 'A Murabaha Financing Transaction is already associated with this email address!',
  [IDS.REGISTER_SERVICE_ERROR_EMAIL_IN_USE_TEXT]: 'Please log in using credentials for the existing account associated with this email address. If you can\'t remember your credentials, we can help you retrieve them on the login screen. Once logged in, link a new Murabaha Financing Transaction by selecting "Add a New Account" in the Settings section.',
  [IDS.REGISTER_STEP_ONE_ERROR_LINK_LABEL]: 'Register Murabaha Financing Transaction',
  [IDS.REGISTER_SSO_LOAN_ERROR_HEADING]: "We couldn't register your Murabaha Financing Transaction",
  [IDS.REGISTER_STEP_TWO_ERROR_HEADING]: 'Your Murabaha Financing Transaction information doesn\'t match our records',
  [IDS.REGISTER_STEP_TWO_VALIDATION_ERROR_TEXT]: 'Please choose a new username. For questions about registering your Murabaha Financing Transaction, contact Customer Service.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
